<template>
  <div id="forms_list">
    <template>
      <div>
        <v-data-table
          :options.sync="options"
          :server-items-length="totalItems"
          :headers="headers"
          :items="forms"
          :search="searchForm"
          :loading="loading"
          :footer-props="{
            'items-per-page-options': [10, 20, 30, 40, 50, 100]
          }"
          :items-per-page="20"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-subheader>{{ formName }}</v-subheader>
          </template>

          <template v-slot:[`item.action`]="{ item }">
            <v-btn
              v-if="canEdit(item)"
              :href="editItemHref(item)"
              class="mr-1"
              small
              icon
            >
              <v-icon small>
                mdi-eye
              </v-icon>
            </v-btn>
            <v-btn
              v-if="canDelete(item)"
              color="red"
              small
              icon
              @click="deleteItem(item)"
            >
              <v-icon small>
                mdi-delete
              </v-icon>
            </v-btn>
          </template>

          <template v-slot:[`item.closed`]="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-if="item.closed"
                  small
                  class="mr-1"
                  v-on="on"
                >
                  mdi-close
                </v-icon>
                <v-icon
                  v-else
                  small
                  class="mr-1"
                  v-on="on"
                >
                  mdi-check
                </v-icon>
              </template>
              <span v-if="item.closed">Archivované/Uzavreté</span>
              <span v-else>Aktívne</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </div>
    </template>
  </div>
</template>


<script>
export default {
  name: "SearchFormsComponent",

  props: {
    formName: { type: String, required: true },
    getItemsFunction: { type: Function, required: true },
    getItem: { type: String, required: true },
    deleteItemFunction: { type: Function, required: true },
    searchForm: { type: String, required: true },
  },

  data: () => ({
    timeout: null,
    dialog: false,
    loading: true,
    totalItems: 0,
    options: {},

    headers: [
      {
        text: "Interné ID",
        value: "id",
      },
      { text: "Základné číslo", value: "prisoner_full.base_number" },
      { text: "Ústav", value: "prisoner_full.institution_full.name" },
      {
        text: "Administrátor",
        value: "created_by_full.username",
      },
      { text: "Vytvorený", value: "created_at" },
      { text: "Posledná zmena", value: "updated_at" },
      { text: "Otvorený", value: "closed" },
      { text: "Akcie", value: "action", sortable: false },
    ],

    forms: [],
  }),

  watch: {
    searchForm() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.getDataFromApi();
      }, 500);
    },
    options: {
      handler() {
        this.getDataFromApi();
      },
    },
    deep: true,
  },
  created() {},

  methods: {
    canDelete(item) {
      if (item.permissions.delete) return true;
      return false;
    },
    canEdit(item) {
      if (item.permissions.change) return true;
      return false;
    },

    getClosed(item) {
      if (item == true) return "uzavretý";
      return "otvorený";
    },
    getColor(item) {
      if (item == true) return "white";
      return "red";
    },

    getForms(sort, search, limit, offset, filter_key, filter_value) {
      this.loading = true;

      this.getItemsFunction(
        sort,
        search,
        limit,
        offset,
        filter_key,
        filter_value
      ).then((response) => {
        this.forms = response.results;
        this.totalItems = response.count;
        this.loading = false;
      });
    },

    // TODO fix v${item.version}
    editItem(item) {
      this.$router.push({
        name: this.getItem,
        params: { id: item.id },
      });
    },

    editItemHref(item) {
      return this.$router.resolve({
        name: this.getItem,
        params: { id: item.id },
      }).href;
    },

    async deleteItem(item) {
      confirm("Naozaj chcete zmazať?") &&
        this.deleteItemFunction(item).then(() => {
          const index = this.forms.indexOf(item);
          this.forms.splice(index, 1);
        });
    },

    getDataFromApi() {
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      let sort = "";
      if (sortBy) {
        if (sortBy.length === 1 && sortDesc.length === 1) {
          sort = sortBy[0].replace(/\./g, "__").replace(/_full/g, "");
          if (!sortDesc[0]) sort = "-" + sort;
        }
      }

      let offset = "";
      if (itemsPerPage > 0) {
        offset = (page - 1) * itemsPerPage;
      }

      this.getForms(sort, this.searchForm, itemsPerPage, offset);
    },
  },
};
</script>